import { ReactElement } from "react";
import { Badge, Card, Flex, Switch } from "@mantine/core";
import { IPaymentFrequencySwitchProps } from "./types";
import { useStyles } from "./PaymentFrequencySwitch.styled";
import { usePlan, usePlansHierarchy } from "@stores/plans/hooks";

export default function PaymentFrequencySwitch({
  "data-testid": dataTestid,
  isYearly,
  planAlias,
  handleChange,
  disabled,
  withBorder,
  ...cardProps
}: IPaymentFrequencySwitchProps): ReactElement {
  const { classes } = useStyles({ disabled, withBorder });

  // plans hierarchy
  const plansHierarchy = usePlansHierarchy();
  const parentPlanObj = plansHierarchy.find(({ type }) => type === planAlias);
  const firstPlanObj = parentPlanObj?.plans && parentPlanObj.plans[0];

  // plan
  const planObj = usePlan({ alias: planAlias || "" }) || firstPlanObj;

  // yearly plan
  const yearlyPlanObj = usePlan({
    alias: planObj ? `${planObj.alias}-yearly` : "",
  });

  return (
    <Card
      withBorder={withBorder}
      bg="gray.1"
      p={withBorder ? "xs" : 0}
      className={classes.card}
      {...cardProps}
    >
      <Flex
        c="gray.5"
        align={{ base: "flex-start", xs: "center" }}
        direction="row"
        justify="space-between"
      >
        <Switch
          data-testid={dataTestid}
          label={
            isYearly ? `Switch to monthly billing` : `Switch to annual billing`
          }
          checked={isYearly}
          onChange={handleChange}
          disabled={disabled}
        />

        <Badge
          color="green.1"
          radius="sm"
          variant="outline"
          bg="green.0"
          c="green.1"
          fw={700}
          fz="xs"
          lts={-0.25}
          tt="none"
        >
          {planObj && yearlyPlanObj && isYearly
            ? `Saving $${planObj.price * 12 - yearlyPlanObj.price} per year`
            : "Save 10%"}
        </Badge>
      </Flex>
    </Card>
  );
}
